/**
 * 检查字符串中是否包含 HTML 标签
 * @param str 需要检测的字符串
 * @returns boolean 是否包含 HTML 标签
 */
export function hasHtmlTag(str: string): boolean {
	if (typeof str !== "string") return false;

	// 去除首尾空格后进行检测
	const trimmed = str.trim();

	// 常用正则匹配 <tag> 或 </tag> 形式
	// eslint-disable-next-line security/detect-unsafe-regex
	const htmlTagRegex = /<([a-z][\w-]*)(\s[^>]*)?>.*?<\/\1>|<([a-z][\w-]*)(\s[^>]*)?\/?>/i;

	return htmlTagRegex.test(trimmed);
}
